import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Contact() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative h-96 flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://readdy.ai/api/search-image?query=Professional%20business%20communication%20concept%20with%20modern%20office%20setting%2C%20contact%20forms%2C%20phone%20calls%2C%20and%20customer%20service%20representatives%20helping%20clients%20with%20industrial%20background%20and%20technology%20elements&width=1920&height=600&seq=contact-hero&orientation=landscape')`
        }}
      >
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-amber-300 to-yellow-400 bg-clip-text text-transparent">
            お問い合わせ
          </h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto">
            金属加工のお困りごとから専門サービスまで<br />
            お気軽にご相談ください
          </p>
        </div>
      </section>

      {/* Contact Information Section */}
      <section className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Information */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">お急ぎの方は直接お電話を</h2>
              
              <div className="bg-gradient-to-br from-amber-50 to-yellow-50 rounded-lg p-8 mb-8 border-2 border-amber-400">
                <h3 className="text-xl font-bold text-gray-900 mb-6">会社情報</h3>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center mr-3 mt-1">
                      <i className="ri-building-line text-amber-600"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-gray-900">メタルリンク株式会社</p>
                      <p className="text-gray-600 text-sm">METAL LINK Co,Ltd.</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center mr-3 mt-1">
                      <i className="ri-user-line text-amber-600"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-gray-900">代表取締役</p>
                      <p className="text-gray-600">大森 孝人(Oomori Takato)</p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center mr-3 mt-1">
                      <i className="ri-map-pin-line text-amber-600"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-gray-900">所在地</p>
                      <p className="text-gray-600">〒822-0002</p>
                      <p className="text-gray-600">福岡県直方市上頓野4711-7</p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center mr-3 mt-1">
                      <i className="ri-mail-line text-amber-600"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-gray-900">メール</p>
                      <a href="mailto:t_oomori@metal-link.jp" className="text-amber-600 hover:text-amber-700 transition-colors cursor-pointer">
                        t_oomori@metal-link.jp
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center mr-3 mt-1">
                      <i className="ri-phone-line text-amber-600"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-gray-900">電話番号</p>
                      <a href="tel:0949528650" className="text-amber-600 hover:text-amber-700 transition-colors cursor-pointer">
                        0949-52-8650
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center mr-3 mt-1">
                      <i className="ri-global-line text-amber-600"></i>
                    </div>
                    <div>
                      <p className="font-semibold text-gray-900">ウェブサイト</p>
                      <a href="https://www.metal-link.jp" className="text-amber-600 hover:text-amber-700 transition-colors cursor-pointer">
                        www.metal-link.jp
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg p-8 border-2 border-gray-400">
                <h3 className="text-xl font-bold text-gray-900 mb-6">対応可能サービス</h3>
                <div className="grid grid-cols-1 gap-4">
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">金属加工</h4>
                    <p className="text-gray-600 text-sm">鉄・非鉄・鋳物・表面処理・木型・旋盤・MC・研削・板金・製缶・溶接・砥石</p>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">紹介業務</h4>
                    <p className="text-gray-600 text-sm">工場塗装・人材紹介・興信所・税理士・社会労務士</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Business Hours */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">営業時間</h2>
              
              <div className="bg-gradient-to-br from-amber-50 to-yellow-50 rounded-lg p-8 border-2 border-amber-400">
                <div className="space-y-6">
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-4">営業日</h3>
                    <div className="space-y-3">
                      <div className="flex items-center justify-between">
                        <span className="text-gray-700 font-medium">月曜日 - 金曜日</span>
                        <span className="text-amber-600 font-semibold">8:00 - 17:00</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-700 font-medium">土曜日</span>
                        <span className="text-gray-500">定休日</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-700 font-medium">日曜日・祝日</span>
                        <span className="text-gray-500">定休日</span>
                      </div>
                    </div>
                  </div>

                  <div className="border-t-2 border-amber-200 pt-6">
                    <h3 className="text-lg font-bold text-gray-900 mb-3">
                      <i className="ri-information-line text-amber-600 mr-2"></i>
                      お問い合わせについて
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      メールでのお問い合わせは24時間受け付けております。営業時間外のお問い合わせにつきましては、翌営業日以降に順次ご対応させていただきます。
                    </p>
                  </div>

                  <div className="bg-white rounded-lg p-6 border-2 border-amber-200">
                    <h3 className="text-lg font-bold text-gray-900 mb-3">
                      <i className="ri-phone-line text-amber-600 mr-2"></i>
                      お急ぎの場合
                    </h3>
                    <p className="text-gray-600 text-sm mb-4">
                      お急ぎの場合は、営業時間内に直接お電話にてお問い合わせください。担当者が迅速に対応いたします。
                    </p>
                    <a 
                      href="mailto:t_oomori@metal-link.jp"
                      className="inline-flex items-center justify-center w-full bg-gradient-to-r from-amber-400 to-yellow-500 hover:from-amber-500 hover:to-yellow-600 text-gray-900 px-6 py-3 rounded-lg font-semibold transition-all cursor-pointer whitespace-nowrap shadow-lg"
                    >
                      <i className="ri-mail-line mr-2"></i>
                      メールでお問い合わせ
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">アクセス</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-400 to-yellow-500 mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              福岡県直方市上頓野に拠点を構えています
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-lg overflow-hidden border-4 border-amber-400/20">
            <div className="h-96">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7888.367601693025!2d130.7556373723213!3d33.76970865567036!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3543cfd64eaa0685%3A0xac09eac16f543a46!2z44CSODIyLTAwMDMg56aP5bKh55yM55u05pa55biC5LiK6aCT6YeO77yU77yX77yR77yR4oiS77yX!5e0!3m2!1sja!2sjp!4v1766376284845!5m2!1sja!2sjp"
                width="100%"
                height="100%"
                style={{ border: 0, borderRadius: '0.5rem' }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="メタルリンク株式会社の所在地"
              ></iframe>
            </div>
            <div className="p-6 bg-gradient-to-br from-amber-50 to-yellow-50">
              <div className="flex items-center">
                <div className="w-6 h-6 flex items-center justify-center mr-3">
                  <i className="ri-map-pin-line text-amber-600"></i>
                </div>
                <div>
                  <p className="font-semibold text-gray-900">メタルリンク株式会社</p>
                  <p className="text-gray-600">〒822-0002 福岡県直方市上頓野4711-7</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">よくあるご質問</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-400 to-yellow-500 mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              お客様からよくいただくご質問をまとめました
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-gradient-to-br from-amber-50 to-yellow-50 rounded-lg p-6 border-l-4 border-amber-400">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                <i className="ri-question-line text-amber-600 mr-2"></i>
                小ロットでも対応可能ですか？
              </h3>
              <p className="text-gray-600">
                はい、1個からでも対応いたします。試作品や少量生産もお気軽にご相談ください。
              </p>
            </div>

            <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg p-6 border-l-4 border-gray-400">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                <i className="ri-question-line text-gray-600 mr-2"></i>
                図面がなくても相談できますか？
              </h3>
              <p className="text-gray-600">
                もちろんです。現物やスケッチからでも対応可能です。最適な加工方法をご提案いたします。
              </p>
            </div>

            <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg p-6 border-l-4 border-gray-400">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                <i className="ri-question-line text-gray-600 mr-2"></i>
                納期はどのくらいですか？
              </h3>
              <p className="text-gray-600">
                加工内容により異なりますが、通常1〜2週間程度です。お急ぎの場合はご相談ください。
              </p>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-yellow-50 rounded-lg p-6 border-l-4 border-amber-400">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                <i className="ri-question-line text-amber-600 mr-2"></i>
                見積もりは無料ですか？
              </h3>
              <p className="text-gray-600">
                はい、お見積もりは無料です。図面や仕様をお送りいただければ、迅速に対応いたします。
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
